import { Component, Input }   from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgForm }             from '@angular/forms';

import { CodeTypeModel }   from '../../app-lite/core/models/code-type';
import { MessagesService } from '../../app-lite/messages/messages.service';
import { XeroService }     from '../../app-lite/xero/xero.service';

@Component({
  selector   : 'wor-xero-country',
  template: require('./xero.country.component.html')
})
export class XeroCountryComponent {
  @BlockUI('xeroCountryBlock') block : NgBlockUI;

  @Input() countries : Array<CodeTypeModel>;

  country: string;

  constructor (
    private messagesService: MessagesService,
    private xeroService    : XeroService
  ) {}

  submit ( form : NgForm ) : void {
    this.block.start();

    this.xeroService.getSignupUrlFromCountry(this.country)
    .then(( url : string ) => {
      window.location.assign(url);
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
